export default __webpack_public_path__ + "static/media/fundo jornada de desenvolvimento.e9e11a76.svg";